"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var translate_1 = require("utils/translate");
var toastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var currentActions = require("@caddigital/sok-reducers/lib/actions/congrid/current");
var filesActions = require("@caddigital/sok-reducers/lib/actions/congrid/files");
var metasActions = require("@caddigital/sok-reducers/lib/actions/congrid/metas");
var linkActions = require("@caddigital/sok-reducers/lib/actions/congrid/link");
var Types = require("types");
var step1_1 = require("./step1");
var step2_1 = require("./step2");
require("./style.scss");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        selectedLanguage: selectedLanguage,
        current: state.congrid.current,
        files: state.congrid.files,
        folderContent: state.congrid.files.folderContent,
        congridMetas: state.congrid.metas,
        link: state.congrid.link,
        metaDataColumns: state.files.metadata
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    addToast: function (title, message) {
        return dispatch(toastActions.addNewToast(title, message));
    },
    getProject: function (id) { return dispatch(currentActions.fetchRequest(id)); },
    getFiles: function (id) { return dispatch(filesActions.fetchRequest(id)); },
    selectItem: function (folder, value) {
        dispatch(filesActions.FolderTreeActions.selectFile(folder, value));
    },
    changeExpand: function (expand, folder) {
        return dispatch(filesActions.FolderTreeActions.copyChangeExpand(expand, folder));
    },
    getContent: function (parent) {
        return dispatch(filesActions.FolderTreeActions.fetchTree(parent, ['FOLDER', 'PDF'], 'COMPLETE'));
    },
    getCongridMetas: function (n) { return dispatch(metasActions.fetchRequest(n)); },
    linkFiles: function (items) {
        return dispatch(linkActions.linkRequest(items));
    },
    clear: function () { return (dispatch(currentActions.clear()),
        dispatch(filesActions.FolderTreeActions.copyFilesReset()),
        dispatch(linkActions.clear()),
        dispatch(metasActions.clear()),
        dispatch(filesActions.clear())); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.withState)('step', 'setStep', 0), (0, recompose_1.withState)('metas', 'setMetas', []), (0, recompose_1.withState)('validationErrors', 'setValidationErrors', {}), (0, recompose_1.withState)('failedColumns', 'setFailedColumns', []), (0, recompose_1.withState)('processed', 'setProcessed', []), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        var id = parseInt(this.props.match.params.id, 10);
        if (!isNaN(id)) {
            this.props.getProject(id);
            this.props.getFiles(id);
            this.props.getCongridMetas(id);
        }
        this.props.getContent({
            id: this.props.currentProject.rootFolder,
            project: this.props.currentProject.id
        });
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
var send = function (props) {
    var project = props.current.project;
    var errors = {};
    var columns = [];
    if (project) {
        var rows = props.processed.reduce(function (acc, x) {
            var cm = x.customMeta.find(function (m) { return m.identifier === 'congrid-meta'; });
            if (!cm) {
                columns.push('congrid-meta');
                errors[x.uuid] = {
                    'congrid-meta': true
                };
                return acc;
            }
            var meta = props.congridMetas.items.find(function (z) { return z.id === cm.value; });
            if (!meta) {
                columns.push('congrid-meta');
                errors[x.uuid] = {
                    'congrid-meta': true
                };
                return acc;
            }
            var file = __assign(__assign({}, x), { congrid: {
                    id: null,
                    floorPlanTypeId: meta.id,
                    projectId: project.congridId,
                    slug: null
                } });
            acc.push({
                file: file,
                congridProject: project
            });
            return acc;
        }, []);
        if (columns.length) {
            props.addToast((0, translation_1.getLocalization)('congrid/link/validation/title'), (0, translation_1.getLocalization)('congrid/link/validation/message'));
            props.setFailedColumns(columns);
            props.setValidationErrors(errors);
        }
        else {
            props.linkFiles(rows);
        }
    }
};
var steps = ['Files', 'Metas'];
exports.default = enhance(function (props) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    if (props.link.status !== 'STANDBY') {
        return (React.createElement("div", { className: 'content-wrapper-content' },
            React.createElement("div", { className: 'congrid-link-view' },
                React.createElement("main", { className: 'content' },
                    React.createElement("div", { className: 'loading' },
                        React.createElement(sok_ui_1.RequestSpinner, { isLoading: props.link.status === 'SENDING', success: props.link.status === 'SENDED' }),
                        React.createElement("div", { className: props.link.status.toLowerCase() },
                            props.link.status === 'SENDING' &&
                                (0, translation_1.getLocalization)('congrid/link/sending/message'),
                            props.link.status === 'FAILED' &&
                                (0, translation_1.getLocalization)('congrid/link/failed/message'),
                            props.link.status === 'SENDED' &&
                                (0, translation_1.getLocalization)('congrid/link/success/message'))),
                    React.createElement(sok_ui_1.Footer, null,
                        React.createElement(sok_ui_1.Button, { disabled: props.link.status !== 'FAILED', icon: React.createElement(sok_ui_1.Icon, { className: 'fa-link' }), color: 'blue', text: (0, translation_1.getLocalization)('generic/tryAgain'), onClick: function () { return send(props); } }),
                        React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('buttons/close'), url: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/congrid?project=").concat(props.match.params.id) }))))));
    }
    if (props.current.status === 'FETCHING' ||
        props.current.status === 'STANDBY' ||
        props.files.status === 'FETCHING' ||
        props.files.status === 'STANDBY' ||
        props.metaDataColumns.status !== 'FETCHED') {
        return (React.createElement("div", { className: 'content-wrapper-content' },
            React.createElement("div", { className: 'congrid-link-view' },
                React.createElement("main", { className: 'content' },
                    React.createElement("div", { className: 'loading' },
                        React.createElement(sok_ui_1.LoadingSpinner, null))))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'content-wrapper-content' },
            React.createElement("div", { className: 'congrid-link-view' },
                React.createElement("main", { className: 'content' },
                    React.createElement(sok_ui_1.BreadCrumb, null,
                        React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id) }, props.currentProject.name),
                        React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/congrid") }, (0, translation_1.getLocalization)('breadcrumb/congrid')),
                        React.createElement("span", null, props.current.project && props.current.project.name)),
                    React.createElement("div", { className: 'wizard' },
                        React.createElement("div", null,
                            React.createElement(sok_ui_1.StepBar, { showStepText: false, steps: steps, currentStep: props.step, onChange: props.setStep })),
                        props.step === 0 && props.folderContent.data.tree && (React.createElement(step1_1.default, { linkedFiles: props.files.items, currentProject: props.currentProject, tree: props.folderContent.data.tree, loadingFolder: props.folderContent.data.loading
                                ? [props.folderContent.data.loading.uuid]
                                : [], selectItem: props.selectItem, changeExpand: props.changeExpand, getContent: props.getContent, addToast: props.addToast })),
                        props.step === 1 && (React.createElement(step2_1.default, { currentProject: props.currentProject, selectedLanguage: props.selectedLanguage, getLocalization: translation_1.getLocalization, items: props.folderContent.data.tree
                                ? props.folderContent.data.tree
                                    .getNodes()
                                    .filter(function (x) { return x.getSelected(); })
                                    .map(function (x) { return x.getValue(); })
                                : [], errors: props.validationErrors, metaDataColumns: props.metaDataColumns.list, failedColumns: props.failedColumns, displayLocked: false, congridMetas: props.congridMetas.items, metas: props.metas, setMetas: props.setMetas, processed: props.processed, setProcessed: props.setProcessed }))),
                    React.createElement(sok_ui_1.Footer, null,
                        React.createElement(sok_ui_1.Button, { disabled: props.step < 1, icon: React.createElement(sok_ui_1.Icon, { className: 'fa-chevron-left' }), color: 'blue', text: (0, translation_1.getLocalization)('buttons/previous'), onClick: function () { return props.setStep(props.step - 1); } }),
                        React.createElement(sok_ui_1.Button, { disabled: props.step > 0, iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-chevron-right' }), color: 'blue', text: (0, translation_1.getLocalization)('buttons/next'), onClick: function () { return props.setStep(props.step + 1); } }),
                        React.createElement(sok_ui_1.Button, { iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-link' }), disabled: props.step < 1 || props.processed.length === 0, color: 'green', text: (0, translation_1.getLocalization)('buttons/link'), onClick: function () { return send(props); } }),
                        React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('buttons/close'), url: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/congrid?project=").concat(props.match.params.id) })))))));
});
